<div class="dx-card wide-card">
    <div class="content-block">
        <dx-responsive-box labelLocation="top" singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".3"></dxi-col>
            <dxi-item>
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label filterlable"><span class="error">*</span> Start Award Year</div>
                    <div class="dx-field-value">
                        <dx-select-box #startAwardYear [dataSource]="awardYears" placeholder="Choose" displayExpr=''
                            valueExpr='' [searchEnabled]="true" [(value)]="selectedStartAwardYear">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Start Award Year is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label filterlable"><span class="error">*</span> End Award Year</div>
                    <div class="dx-field-value">
                        <dx-select-box #endAwardYear [dataSource]="awardYears" placeholder="Choose" displayExpr=''
                            valueExpr='' [searchEnabled]="true" [(value)]="selectedEndAwardYear">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="End Award Year is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label filterlable"><span class="error">*</span> Status</div>
                    <div class="dx-field-value">
                        <dx-tag-box #status [items]="statusDataSource" [maxFilterQueryLength]="5000" [multiline]="false"
                            [(value)]="selectedStatus" [showSelectionControls]="true">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Status is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-tag-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="1"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label filterlable"><span class="error">*</span> Segment</div>
                    <div class="dx-field-value">
                        <dx-tag-box #segments [items]="segmentDataSource" [maxFilterQueryLength]="5000"
                            [multiline]="false" [(value)]="selectedSegment" [showSelectionControls]="true">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Segment is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-tag-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="2"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label filterlable"><span class="error">*</span> Competitor</div>
                    <div class="dx-field-value">
                        <dx-tag-box #competitors [items]="competitorDataSource" [maxFilterQueryLength]="5000"
                            [multiline]="false" [(value)]="selectedCompetitor" [showSelectionControls]="true">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Competitor is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-tag-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="3"></dxi-location>
                <div class="dx-field btndiv">
                    <dx-button class="ap-blue-btn" type="default" (onClick)="viewReport()" text="View Reports">
                    </dx-button>
                </div>
            </dxi-item>
        </dx-responsive-box>
        <hr />
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div class="content-block">
        <dx-tab-panel #crmOuterTabPanel [selectedIndex]="0" [loop]="true" (onTitleClick)="renderReport($event)"
            [deferRendering]="false" [animationEnabled]="true" [swipeEnabled]="false" [visible]="true">
            <dxi-item [title]="'Investment Details'">
                <app-asu-smr-details [asuAndHYCOInvestmentFilters]="asuAndHYCOInvestmentFilters"></app-asu-smr-details>
            </dxi-item>
            <dxi-item [title]="'Charts'">
                <app-asu-smr-charts [asuAndHYCOInvestmentFilters]="asuAndHYCOInvestmentFilters"></app-asu-smr-charts>
            </dxi-item>
        </dx-tab-panel>
    </div>
</div>